export const KB_URL_BASE = "https://docs.appoptics.com/kb";
export const KB_APM_URL = `${KB_URL_BASE}/apm_tracing/`;
export const KB_HOST_URL = `${KB_URL_BASE}/host_infrastructure/`;
export const KB_AWS_URL = `${KB_HOST_URL}cloudwatch/`;
export const KB_HEROKU_URL = `${KB_HOST_URL}heroku/`;
export const IAM_CONSOLE_URL = "https://console.aws.amazon.com/iam/home";
export const SAM_INSTRUCTIONS_URL =
  "http://www.solarwinds.com/documentation/en/flarehelp/sam/content/sam-apm-overview.htm";
export const CONTACT_US_URL = "https://www.solarwinds.com/company/contact-us";
export const SALES_EMAIL_URL = "mailto:cloud.sales.team@solarwinds.com";
export const FUNCTION_PROFILING_URL = `${KB_URL_BASE}/apm_tracing/profiling/`;
export const TRACE_CONTEXT_LOGS = `${KB_URL_BASE}/apm_tracing/context-log/`;
export const IIS_INSTRUCTIONS_URL =
  "https://documentation.solarwinds.com/en/success_center/appoptics/content/kb/host_infrastructure/integrations/iis-native.htm";
